import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { decodeToken, getToken } from '../../../utils/TokenUtils';
import axios from 'axios';

const BalanceSheet = ({report,link,value}) => {
  // State to store income data fetched from the API
  const [balanceSheetData, setBalanceSheetData] = useState([]);
  const [loading, setLoading] = useState(true); // To show loading state
  const [error, setError] = useState(null); // For handling errors
  const token = getToken();
  const companyBanner = decodeToken(token, 'banner');
  console.log(companyBanner);
  // Get the current date
  const [currentDate,setCurrentDate] = useState();

  // Company name (You can replace this with your actual company name)
  const companyName = decodeToken(token, 'companyName');
  // Fetch data from the API on component mount
  useEffect(() => {
    setBalanceSheetData(report);
    const formattedDate = new Intl.DateTimeFormat('en-GB').format(new Date(value.date));
    setCurrentDate(formattedDate);
    console.log("curdate: ",formattedDate);
    setLoading(false);
  }, [report]); // Empty array means it runs once on component mount

  // Render a loading message while fetching
  if (loading) {
    return <div>Loading...</div>;
  }

  // Handle errors
  if (error) {
    return <div>{error}</div>;
  }

  // Helper function to remove dollar sign and convert to number
  const parseAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount?.replace(/[^0-9.-]+/g, '')); // Remove any non-numeric characters
    }
    return amount;
  };

  // Group the data by AccountType
  const currentAssetsData = balanceSheetData?.filter(
    (item) =>
      item?.AccountType === 'Main' || item?.AccountType === 'SubCurrentAssets'
  );
  const fixedAssetsData = balanceSheetData?.filter(
    (item) =>
      item?.AccountType === 'Main' || item?.AccountType === 'SubFixedAssets'
  );
  const liabilitiesData = balanceSheetData?.filter(
    (item) =>
      item?.AccountType === 'Main' || item?.AccountType === 'SubLiabilities'
  );
  const equityData = balanceSheetData?.filter(
    (item) => item?.AccountType === 'Main' || item?.AccountType === 'SubEquity'
  );

  // Calculate TotalCurrentAssets, TotalFixedAssets, TotalLiabilities, and TotalEquity
  const totalCurrentAssets = currentAssetsData?.reduce((total, item) => {
    return total + (parseAmount(item?.Balance) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalFixedAssets = fixedAssetsData?.reduce((total, item) => {
    return total + (parseAmount(item?.Balance) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalLiabilities = liabilitiesData?.reduce((total, item) => {
    return total + (parseAmount(item?.Balance) || 0); // Summing up the amounts without dollar sign
  }, 0);

  const totalEquity = equityData?.reduce((total, item) => {
    return total + (parseAmount(item?.Balance) || 0); // Summing up the amounts without dollar sign
  }, 0);

  // Helper function to format amounts with dollar sign
  const formatAmount = (amount) => {
    return `$${amount?.toLocaleString()}`; // Adding $ sign back when displaying the amount
  };

  return (
    <div style={styles.container}>
      {/* Company Name and Date Section */}
      <div style={styles.headerSection}>
        <header style={styles.bannerHeader}>
          <img
            src={`${API_URL}/${companyBanner}`}
            alt="Company Banner"
            style={styles.logo}
          />
        </header>
        <h1 style={styles.companyName}>{companyName}</h1>
        <p style={styles.date}>Balance Sheet as of {currentDate}</p>
      </div>

      <table style={styles.table}>
        {/* <thead>
          <tr>
            <th style={styles.header}>Account</th>
            <th style={styles.header}>Amount ($)</th>
          </tr>
        </thead> */}
        <tbody >
          <tr >
            <td colSpan="2" style={styles.mainAccount}>
              Current Assets
            </td>
          </tr>
          {currentAssetsData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubCurrentAssets'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubCurrentAssets'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item?.Balance||0))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Current Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalCurrentAssets)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Fixed Assets
            </td>
          </tr>
          {fixedAssetsData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubFixedAssets'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubFixedAssets'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item?.Balance||0))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Fixed Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalFixedAssets)}
            </td>
          </tr>
          <tr>
            <td style={styles.totalLabel}>Total Assets</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalFixedAssets + totalCurrentAssets)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Liabilities
            </td>
          </tr>
          {liabilitiesData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubLiabilities'
                  ? styles.subAccountRow
                  : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubLiabilities'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item?.Balance||0))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Liabilities</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalLiabilities)}
            </td>
          </tr>

          <tr>
            <td colSpan="2" style={styles.mainAccount}>
              Equity
            </td>
          </tr>
          {equityData.map((item, index) => (
            <tr
              key={index}
              style={
                item.AccountType === 'SubEquity' ? styles.subAccountRow : {}
              }
            >
              <td
                style={
                  item.AccountType === 'SubEquity'
                    ? styles.subAccountLabel
                    : styles.rowLabel
                }
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item.Account}
              </td>
              <td style={styles.rowAmount}>
                {formatAmount(parseAmount(item?.Balance||0))}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total Equity</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalEquity)}
            </td>
          </tr>
          <tr>
            <td style={styles.totalLabel}>Total Liabilities & Equity</td>
            <td style={styles.rowAmount} className="fw-bold">
              {formatAmount(totalEquity + totalLiabilities)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    width: '90%',
    margin: 'auto',
    paddingTop: '20px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#333',
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  bannerHeader: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  logo: {
    width: '90%',
    height: '150px',
    objectFit: 'fit',
  },
  companyName: {
    fontSize: '26px',
    fontWeight: 'bold',
    margin: '10px 0 5px',
  },
  date: {
    fontSize: '17px',
    fontWeight:"bold",
    color: '#777',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  },
  header: {
    padding: '10px',
    textAlign: 'left',
    border: '1px solid #ddd',
    backgroundColor: '#f4f4f4',
    fontWeight: 'bold',
  },
  rowLabel: {
  padding: '10px',
  border: '1px solid #ddd',
  verticalAlign: 'top',
  fontSize: '16px',        // increase font size for account names
  fontWeight: '500',       // slightly bolder for clarity
},
  rowAmount: {
  padding: '10px',
  border: '1px solid #ddd',
  textAlign: 'right',
  verticalAlign: 'top',
  fontSize: '16px',        // increase font size for values
  fontWeight: '600',       // make values a bit bolder
  color: '#222',           // slightly darker for emphasis
},
  mainAccount: {
  padding: '10px',
  backgroundColor: '#e8f0fe',
  fontWeight: '700',
  border: '1px solid #ccc',
  fontSize: '18px',       // bigger for section headers
},
  subAccountRow: {
    backgroundColor: '#f9f9f9',
  },
  subAccountLabel: {
  paddingLeft: '32px',
  padding: '10px',
  border: '1px solid #ddd',
  fontSize: '15px',        // slightly smaller but bigger than before
  fontWeight: '400',
},
  totalLabel: {
  fontWeight: '700',
  padding: '10px',
  backgroundColor: '#e2e2e2',
  textAlign: 'left',
  border: '1px solid #ccc',
  fontSize: '17px',       // bigger for totals
},
};



export default BalanceSheet;
